import React, { useState, useRef, useEffect } from "react";
import styles from "./disciplineIndexTable.module.css";
import InfoIcon from "../../../assets/icons/info-icon.svg";
import ChartMixedPorcentageIcon from "../../../assets/icons/chart-mixed-porcentage.svg";
import { formatNumberToCurrency } from "../../../utils/formatter";

const DisciplineIndexTable = ({ disciplineData = null }) => {
  const [showPopover, setShowPopover] = useState(false);
  const popRef = useRef(null);

  // Se disciplineData é um array, pega o primeiro item (maior ticket médio)
  // Se é um objeto, usa diretamente
  const topCourse = Array.isArray(disciplineData) 
    ? disciplineData[0] 
    : disciplineData;

  const hasNoData = !topCourse || !topCourse.courseTitle;

  useEffect(() => {
    if (showPopover && popRef.current) {
      const rect = popRef.current.getBoundingClientRect();
      if (rect.right > window.innerWidth - 8) {
        popRef.current.style.left = `-${rect.width + 8}px`;
      } else {
        popRef.current.style.left = '100%';
      }
    }
  }, [showPopover]);

  if (hasNoData) {
    return (
      <div className={styles.disciplineCard}>
        <img src={ChartMixedPorcentageIcon} alt="" className={styles.icon} />
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <h6 className={styles.title}>Curso com maior ticket médio</h6>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img
                src={InfoIcon}
                alt="Informação"
                style={{ cursor: 'pointer', width: 14, height: 14 }}
                onClick={() => setShowPopover(prev => !prev)}
              />
              {showPopover && (
                <div
                  ref={popRef}
                  className={styles.popover}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    marginLeft: 8,
                    zIndex: 100,
                  }}
                >
                  <p style={{ margin: 0 }}>
                    Curso com maior ticket médio no período selecionado.
                  </p>
                  <button
                    type="button"
                    className={styles.closeBtn}
                    onClick={() => setShowPopover(false)}
                  >
                    Fechar
                  </button>
                </div>
              )}
            </div>
          </div>
          <h2 className={styles.value}>Nenhum dado encontrado</h2>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.disciplineCard}>
      <img src={ChartMixedPorcentageIcon} alt="" className={styles.icon} />
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <h6 className={styles.title}>Top Curso - Ticket Médio</h6>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img
              src={InfoIcon}
              alt="Informação"
              style={{ cursor: 'pointer', width: 14, height: 14 }}
              onClick={() => setShowPopover(prev => !prev)}
            />
            {showPopover && (
              <div
                ref={popRef}
                className={styles.popover}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: '100%',
                  marginLeft: 8,
                  zIndex: 100,
                }}
              >
                <p style={{ margin: 0 }}>
                  Curso com maior ticket médio no período selecionado.
                </p>
                <button
                  type="button"
                  className={styles.closeBtn}
                  onClick={() => setShowPopover(false)}
                >
                  Fechar
                </button>
              </div>
            )}
          </div>
        </div>
        <h2 className={styles.value}>{formatNumberToCurrency(topCourse.ticketMedio)}</h2>
        <p className={styles.courseName}>{topCourse.courseTitle}</p>
      </div>
    </div>
  );
};

export default DisciplineIndexTable; 